export default Object.freeze({
  MEDIUM: 1,
  HIGH: 2,
});
